import React, { useEffect, useState } from "react";

import getSponsoredArticles, {
  ArticleSponsorId,
  ArticleSponsorType,
  SponsoredArticle,
} from "api/requests/getSponsoredArticles";

import ArticleCard from "components/botanic/ArticleCard";
import Carousel from "components/botanic/Carousel";

export const SponsoredArticlesCarousel = ({
  sponsorType,
  sponsorId,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  sponsorType: ArticleSponsorType;
  sponsorId: ArticleSponsorId;
}) => {
  const [articles, setArticles] = useState<SponsoredArticle[] | null>();

  useEffect(() => {
    getSponsoredArticles({ id: sponsorId, sponsorType }).then(setArticles);
  }, []);

  if (!articles?.length) {
    return null;
  }

  return (
    <div {...props}>
      <Carousel title="Related articles" seeMoreHref="/news">
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            className="mb-md elevation-low rounded overflow-hidden block"
            author={article.author}
            date={article.date}
            href={article.link}
            tags={article.tags}
            title={article.title}
            imageUrl={article.image}
            sizes={[750]}
          />
        ))}
      </Carousel>
    </div>
  );
};
